import VideoPlayer from './videoplayer';

export default VideoPlayer;